import { LOCALES } from 'utils/constants/general/locales';

const homepagePaths = Object.keys(LOCALES).map((locale) => `/${locale}`);

export function onHomepage(pathname: string) {
  return homepagePaths.includes(pathname);
}
